import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import OneSelectionFilter from '@components/Templates/FilterPanel/OneSelectionFilter';
import { PRICES } from '@common/types';
import type { QueryParams } from '@common/types';

type Props = {};

const PriceFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  const createUpdatedQueryParam = (selectedItem?: string): QueryParams => ({
    price: selectedItem,
  });

  return (
    <OneSelectionFilter
      selectedValue={filters.price || PRICES.ALL}
      items={PRICES}
      langTokenPrefix={'marketplace.templates-page.price-type-'}
      createUpdatedQueryParam={createUpdatedQueryParam}
      dataHook={'price'}
    />
  );
};

export default PriceFilter;
